/* tslint:disable */
/* eslint-disable */
/**
 * esign
 * eSign template authoring and request management service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const EsignSignerStatus = {
    Pending: 'Pending',
    Requested: 'Requested',
    Completed: 'Completed'
} as const;
export type EsignSignerStatus = typeof EsignSignerStatus[keyof typeof EsignSignerStatus];


export function EsignSignerStatusFromJSON(json: any): EsignSignerStatus {
    return EsignSignerStatusFromJSONTyped(json, false);
}

export function EsignSignerStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): EsignSignerStatus {
    return json as EsignSignerStatus;
}

export function EsignSignerStatusToJSON(value?: EsignSignerStatus | null): any {
    return value as any;
}

